import type { HTMLAttributes } from 'react';

export const Notification5Fill = (props: HTMLAttributes<HTMLOrSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 9 12" {...props}>
      <path
        fill="currentColor"
        d="M4.5.856a.642.642 0 0 0-.643.643v.386a3.216 3.216 0 0 0-2.572 3.15v.377c0 .945-.347 1.857-.974 2.564l-.149.167a.642.642 0 0 0 .48 1.07h7.715a.644.644 0 0 0 .48-1.07l-.149-.167a3.863 3.863 0 0 1-.974-2.564v-.377a3.216 3.216 0 0 0-2.572-3.15v-.386A.642.642 0 0 0 4.5.856Zm.91 9.91c.24-.24.375-.568.375-.91H3.214a1.286 1.286 0 0 0 2.196.91Z"
      />
    </svg>
  );
};
